import solutionImageOne from '@/assets/images/our_solutions_01.png'
import solutionImageTwo from '@/assets/images/our_solutions_02.png'
import solutionImageThree from '@/assets/images/our_solutions_03.png'
import workImageOne from '@/assets/images/our_work_01.png'
import workImageTwo from '@/assets/images/our_work_02.png'

export type Product = {
  category: string
  description: string
  imageSrc: string
  item: string
  title: string
}

export const products: Product[] = [
  { category: 'Roofing', description: 'Insulated roof panel with PIR core for excellent thermal performance.', imageSrc: solutionImageOne, item: 'TEC-RP-CR-50', title: 'Kingcore PIR Roof Panel 5-Rib' },
  { category: 'Wall', description: 'Insulated wall panel with micro-rib profile for modern facades.', imageSrc: solutionImageTwo, item: 'TEC-WP-MR-50', title: 'Kingcore PIR Wall Panel Micro-Rib' },
  { category: 'Metal', description: 'High quality galvanized steel structure system for durable buildings.', imageSrc: solutionImageThree, item: 'TEC-SS-G-90', title: 'Steel Structure System Galvanized' },
  { category: 'Roofing', description: 'Insulated roof panel with clean rib profile for strong roof systems.', imageSrc: solutionImageOne, item: 'TEC-RP-3R-50', title: 'Kingcore PIR Roof Panel 3-Rib' },
  { category: 'Accessory', description: 'Fastener set for panel installation and metal building systems.', imageSrc: workImageOne, item: 'TEC-FS-500', title: 'Fasteners and Screw Set' },
  { category: 'Insulation', description: 'Insulation membrane roll for roof and wall system protection.', imageSrc: workImageTwo, item: 'TEC-IM-100', title: 'Insulation Membrane Roll' },
]
